var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneLine = function SvgPhoneLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.025 9.012a7.9 7.9 0 0 0 2.964 2.964l.662-.929a.75.75 0 0 1 .971-.222c1.06.58 2.232.928 3.437 1.023a.75.75 0 0 1 .691.748v3.346a.75.75 0 0 1-.674.747q-.596.06-1.201.061c-6.42 0-11.625-5.205-11.625-11.625q0-.606.062-1.201a.75.75 0 0 1 .746-.674h3.346a.75.75 0 0 1 .748.69 8.6 8.6 0 0 0 1.023 3.438.75.75 0 0 1-.222.97zm-1.892-.493L7.558 7.5c-.404-.873-.681-1.8-.823-2.751H4.758q-.007.188-.007.375C4.75 10.717 9.283 15.25 14.875 15.25q.188 0 .375-.008v-1.977a10 10 0 0 1-2.751-.823l-1.018 1.425a9 9 0 0 1-1.19-.562l-.044-.025A9.4 9.4 0 0 1 6.72 9.753l-.024-.043a9 9 0 0 1-.563-1.191"
  })));
};
export default SvgPhoneLine;